/** Browser-style search tabs. true in test; false in production until launch. */
export const isSearchTabsEnabled = process.env.REACT_APP_SHOW_SEARCH_TABS === 'true';
